// lets parcel know where to look for the leaflet marker icon images
// based on: https://stackoverflow.com/a/51232969

import { icon, Marker } from 'leaflet';
import iconRetinaUrl from 'url:/node_modules/leaflet/dist/images/marker-icon-2x.png';
import iconUrl from 'url:/node_modules/leaflet/dist/images/marker-icon.png';
import shadowUrl from 'url:/node_modules/leaflet/dist/images/marker-shadow.png';
const iconDefault = icon({
  iconRetinaUrl,
  iconUrl,
  shadowUrl,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  tooltipAnchor: [16, -28],
  shadowSize: [41, 41]
});
Marker.prototype.options.icon = iconDefault;
export default Marker;